import { WidgetGrid } from '@/components/WidgetGrid';

export function DashboardPage() {
  return <WidgetGrid />;
}
